/**
 *
 * Simple Cookie Storage
 *  for simple data & backend coverage
 *
 */

import cookies from 'react-cookies';
import { toDate, addHours, addMinutes } from 'date-fns';

export const CS_PROMOCODE = 'ts_promocode';
export const CS_SUBSCRIBE_TM = 'ts_sub_tm';
export const CS_TOKEN_CART = 'ts_token_cart';
export const CS_DISABLE_ANALYTICS = 'ts_disable_analytics';

const CookiesStorage = {
    get: (name, returnDefault = null) => {
        const value = cookies.load(name);
        if (value) {
            return value;
        }

        return returnDefault;
    },
    set: (name, data = '', opt = { path: '/' }) => cookies.save(name, data, opt),
    remove: (name) => cookies.remove(name),
};

const getStorage = () => CookiesStorage;

export const get = (name, returnDefault) => getStorage().get(name, returnDefault);
export const set = (name, value, options) => getStorage().set(name, value, options);
export const remove = (name) => getStorage().remove(name);

export const load = (s) => {
    try {
        return get(s, null);
    } catch (err) {
        console.log(err);
        return null;
    }
};

export const save = (string, value, options) => {
    try {
        return set(string, value, options);
    } catch (err) {
        console.log(err);
        return null;
    }
};

export const loadPromocode = () => load(CS_PROMOCODE);
export const savePromocode = (value) =>
    save(CS_PROMOCODE, value, {
        path: '/',
        expires: toDate(addHours(new Date(), 48)),
    });

export const loadSubTm = async () => {
    const test = await load(CS_SUBSCRIBE_TM);
    return test;
};
export const saveSubTm = (value) => save(CS_SUBSCRIBE_TM, value);
export const loadTokenCart = () => load(CS_TOKEN_CART);
export const saveTokenCart = (value) => save(CS_TOKEN_CART, value);
export const loadProductListClick = () => load('_tsinls') || '';
export const saveProductListClick = (value = '') =>
    save('_tsinls', value, {
        path: '/',
        expires: toDate(addMinutes(new Date(), 1)),
    });
